import { render, staticRenderFns } from "./OrderAddressDetail.vue?vue&type=template&id=f7e3e172&scoped=true&"
import script from "./OrderAddressDetail.vue?vue&type=script&lang=js&"
export * from "./OrderAddressDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddressDetail.vue?vue&type=style&index=0&id=f7e3e172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e3e172",
  null
  
)

export default component.exports